import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	loading: false,
	error: null,
};

export const loadProjectSiteAreas = createAsyncThunk(
	"projectSiteArea/loadAll",
	async (_, { rejectWithValue }) => {
		try {
			const { data } = await axios.get("projectSite/ProjectSiteAreaDetails");
			return Array.isArray(data) ? data : [];
		} catch (error) {
			return rejectWithValue(
				error?.response?.data ?? {
					message: error?.message || "Unable to load project site areas",
				}
			);
		}
	}
);

export const saveProjectSiteArea = createAsyncThunk(
	"projectSiteArea/save",
	async (payload, { rejectWithValue }) => {
		const { ProjectSiteId, PointsDetails, DataStatus = 1 } = payload || {};
		try {
			const { data } = await axios.post("projectSite/ProjectSiteAreaDetailsSetup", {
				ProjectSiteId,
				PointsDetails,
				DataStatus,
			});
			const messages = Array.isArray(data) ? data : data?.messages || data?.result || [];
			if (Array.isArray(messages) && messages.length) {
				messages.forEach((msg) => {
					if (msg?.status === "error") {
						toast.error(msg?.message || "Project site area request failed");
					} else {
						toast.success(msg?.message || "Project site area saved");
					}
				});
			} else {
				const isDelete = DataStatus === 2;
				toast.success(
					isDelete
						? "Project site area deleted"
						: ProjectSiteId && ProjectSiteId !== 0
						? "Project site area updated"
						: "Project site area added"
				);
			}
			return data;
		} catch (error) {
			const apiError = error?.response?.data;
			const messages = Array.isArray(apiError) ? apiError : apiError?.messages || apiError?.result || [];
			if (Array.isArray(messages) && messages.length) {
				messages.forEach((msg) => {
					toast.error(msg?.message || "Failed to save project site area");
				});
			} else {
				toast.error(apiError?.message || error?.message || "Failed to save project site area");
			}
			return rejectWithValue(
				error?.response?.data ?? {
					message: error?.message || "Unable to save project site area",
				}
			);
		}
	}
);

const projectSiteAreaSlice = createSlice({
	name: "projectSiteArea",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(loadProjectSiteAreas.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(loadProjectSiteAreas.fulfilled, (state, action) => {
				state.loading = false;
				state.list = action.payload ?? [];
			})
			.addCase(loadProjectSiteAreas.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload?.message || "Unable to load project site areas";
			})
			.addCase(saveProjectSiteArea.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(saveProjectSiteArea.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(saveProjectSiteArea.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload?.message || "Unable to save project site area";
			});
	},
});

export default projectSiteAreaSlice.reducer;

